import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/core/hooks';

/**
 * Logout Page
 * Clears authentication state and redirects to login
 */
export const Logout: React.FC = () => {
  const { logout, token } = useAuth();

  // Clear auth state on mount
  React.useEffect(() => {
    if (token) {
      void fetch('/api/auth/logout', {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
      }).catch(() => undefined);
    }
    logout();
  }, [logout, token]);

  // Redirect to login
  return <Navigate to="/login" replace />;
};
